import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CtaSection() {
  return (
    <section data-testid="cta-section" className="py-20 sm:py-28 relative overflow-hidden grid-bg">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full bg-sky-500/10 blur-[160px]" />
      <div className="section-shell relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <Reveal className="lg:col-span-8">
          <p className="micro-label">Free Business Review</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white leading-[1.08]">
            Ready to Turn More Searches Into Customers?
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-400 max-w-xl">
            Tell us about your business and we'll show you where your online presence and customer
            journey can be improved.
          </p>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:justify-self-end" delay={0.15}>
          <a href="#contact" data-testid="cta-business-review" className="btn-primary !px-9 !py-4 text-base">
            Get Your Free Business Review <ArrowRight size={17} strokeWidth={2.5} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
